<template>
  <div :id='id' style="width:100%;height:100%;">
  </div>
</template>
<script>
export default {
  props: {
    index: Number,
    datas: Object,
    id: String
  },
  data() {
    return {
      myChart: null
    }
  },
  mounted() {
    if (this.datas) {
      this.init()
    }
  },
  methods: {
    putMoney(val) {
      return (val / 100).toFixed(2)
    },
    init() {
      let myChart = this.$echarts.init(document.getElementById(this.id))
      this.myChart = myChart
      let _this = this;

      const { qrzq, zzzq } = this.datas
      let dataArr = [     //如果有确认债权的情况下
        { name: '确认债权o', value: zzzq.cause_count - qrzq.cause_count },
        { name: '确认债权', value: qrzq.cause_count }

      ]
      if (qrzq.cause_count === 0) {
        dataArr = [{ name: '么有数据', value: 0 }]
      }
      let option = {
        color: ["#1d8bfe", "#71dcb2"],
        tooltip: {
          show: true,
          position: _this.index == 4 || _this.index == 9 ? ['-50%', '50%'] : ['50%', '50%'],
          padding: 0,
          textStyle: {
            color: '#000',
            decoration: 'none',
          },
          formatter: function (params) {
            const className = _this.index == 4 || _this.index == 9 ? 'right' : ''
            // console.log(qrzq.cause_count, zzzq.cause_count)
            let tipHtml = `<div class='pietip ${className}'>
                <div class='htit'>主张债权</div>
                <div class='dt'>金额：${_this.putMoney(zzzq.fee)}</div>
                <div class='dd'>
                  <div class='d'>案件：${zzzq.cause_count}件</div>
                  <div class='d'>债务人：${zzzq.debtor_count}个</div>
                </div>
                <div class='htit'>确认债权</div>
                <div class='dt'>金额：${_this.putMoney(qrzq.fee)}</div>
                <div class='dd'>
                  <div class='d'>案件：${qrzq.cause_count}件</div>
                  <div class='d'>债务人：${qrzq.debtor_count}个</div>
                  <div class='d longd'>案件占比：${((qrzq.cause_count > 0 ? (qrzq.cause_count / zzzq.cause_count) : 0) * 100).toFixed(2)}%</div>
                </div>
              </div>`
            return tipHtml;
          }
        },
        series: [
          {
            hoverAnimation: false,
            center: ['50%', '38%'],
            type: 'pie',
            radius: [0, 24],
            label: {
              show: false
            },
            data: dataArr
          }
        ],

      };
      this.myChart.setOption(option)
    }
  }
}
</script>
<style lang="less">
.pietip {
  box-shadow: 0 0 10px #eee;
  padding: 10px 16px;
  width: 240px;
  background: #fff;
  border-radius: 4px;
  position: relative;
  &::before {
    position: absolute;
    width: 6px;
    height: 6px;
    background: #1d8bfe;
    border-radius: 50%;
    content: "";
    left: -2px;
    top: -2px;
    border: 1px solid #fff;
  }
  .htit {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 6px;
  }
  .dt,
  .dd {
    font-size: 14px;
    color: #333;
    display: flex;
    flex-wrap: wrap;
    position: relative;

    .d {
      width: 50%;
      display: flex;
      align-items: center;
      &::before {
        width: 6px;
        height: 6px;
        border-radius: 50%;
        content: "";
        background: #40a9ff;
        margin-right: 4px;
      }
    }
  }
  .dt {
    display: flex;
    align-items: center;
    font-size: 13px;
    &::before {
      width: 6px;
      height: 6px;
      border-radius: 50%;
      content: "";
      background: #40a9ff;
      margin-right: 4px;
    }
  }
  .dd {
    margin-bottom: 10px;
    font-size: 13px;
    .longd {
      width: 100%;
    }
    &:nth-last-child(1) {
      margin-bottom: 0;
    }
  }
}
.pietip.right {
  &::before {
    right: -2px;
    left: auto;
  }
}
</style>